<template>
  <div>
    <!-- OLA SVG -->
    <svg
      ref="waveSvg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 320"
      class="animated-wave"
    >
      <defs>
        <linearGradient id="waveGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stop-color="#fff" />
          <stop offset="100%" stop-color="#fff" />
        </linearGradient>
      </defs>
      <path
        ref="wavePathStroke"
        class="wave-path-stroke"
        d="M0,256L80,240C160,224,320,192,480,186.7C640,181,800,203,960,208C1120,213,1280,203,1360,197.3L1440,192L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
      />
      <path
        ref="wavePathFill"
        class="wave-path-fill"
        fill="url(#waveGradient)"
        d="M0,256L80,240C160,224,320,192,480,186.7C640,181,800,203,960,208C1120,213,1280,203,1360,197.3L1440,192L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
      />
    </svg>

    <!-- FOTOS -->
    <div class="rompecabezas-container" ref="containerRef">
      <div class="grid-container">
        <img
          v-for="(foto, index) in fotos"
          :key="index"
          :ref="el => (fotoRefs[index] = el)"
          :src="foto"
          :alt="`Foto ${index + 1}`"
          class="foto-rompecabezas"
          @click="abrirModal(foto)"
        />
      </div>
    </div>

    <!-- MODAL -->
    <div v-if="fotoModal" class="modal" @click="cerrarModal">
      <img :src="fotoModal" class="modal-img" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import gsap from 'gsap';

export default {
  name: 'RompecabezasFotos',
  setup() {
    const containerRef = ref(null);
    const waveSvg = ref(null);
    const wavePathStroke = ref(null);
    const wavePathFill = ref(null);
    const fotoModal = ref(null);

    const fotos = [
      require('@/assets/imagen2_max_calidad.webp'),
     
    ];

    const fotoRefs = [];

    const abrirModal = (foto) => {
      fotoModal.value = foto;
    };

    const cerrarModal = () => {
      fotoModal.value = null;
    };

   const animate = () => {
  const pathLength = wavePathStroke.value.getTotalLength();
  wavePathStroke.value.style.strokeDasharray = pathLength;
  wavePathStroke.value.style.strokeDashoffset = pathLength;

  const tl = gsap.timeline();

  tl.fromTo(waveSvg.value, { opacity: 0, y: -60 }, { opacity: 1, y: 0, duration: 1, ease: 'power2.out' })
    .to(wavePathStroke.value, { strokeDashoffset: 0, duration: 1.2, ease: 'power2.inOut' }, '-=0.7')
    .to(wavePathFill.value, { opacity: 1, duration: 1, ease: 'power1.inOut' }, '-=1');

  fotoRefs.forEach((el, i) => {
    const direction = i % 2 === 0 ? -100 : 100;
    tl.fromTo(
      el,
      { x: direction, y: direction, opacity: 0, scale: 0.85 },
      {
        x: 0,
        y: 0,
        opacity: 1,
        scale: 1,
        duration: 1,
        ease: 'power2.out'
      },
      `-=${0.85 - i * 0.1}` // escalonado
    );
  });
};

    onMounted(() => {
      const observer = new IntersectionObserver(([entry], obs) => {
        if (entry.isIntersecting) {
          animate();
          obs.unobserve(entry.target);
        }
      }, { threshold: 0.3 });

      if (containerRef.value) observer.observe(containerRef.value);
    });

    return {
      containerRef,
      waveSvg,
      wavePathStroke,
      wavePathFill,
      fotos,
      fotoRefs,
      fotoModal,
      abrirModal,
      cerrarModal,
    };
  },
};
</script>

<style scoped>
.rompecabezas-container {
  position: relative;
  width: 100%;
  padding: 80px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.animated-wave {
  width: 100%;
  height: auto;
  pointer-events: none;
  opacity: 0;
}

.wave-path-stroke {
  fill: none;
  stroke: #ffffff;
  stroke-width: 3;
}

.wave-path-fill {
  opacity: 0;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  max-width: 600px;
  width: 90%;
  margin-top: 30px;
}

.foto-rompecabezas {
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  opacity: 0;
  transform-origin: center;
  cursor: pointer;
  transition: transform 0.3s;
}

.foto-rompecabezas:hover {
  transform: scale(1.03);
}

/* MODAL */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  cursor: pointer;
  overflow: auto; /* ✅ Evita desbordes en móviles */
  padding: 20px;   /* ✅ Añade espacio interno */
  box-sizing: border-box;
}

.modal-img {
  max-width: 100%;
  max-height: 90vh;
  border-radius: 15px;
  object-fit: contain;
}

</style>
